"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var mobx_1 = require("mobx");
var json_1 = require("./json");
var Undo = (function () {
    function Undo(state, transactionCompleted) {
        var _this = this;
        this.state = state;
        this.transactionCompleted = transactionCompleted;
        this.undoStack = [];
        this.redoStack = [];
        this.enabled = false;
        this.quit = mobx_1.autorun(function () { return _this.observe(); });
    }
    Undo.prototype.dispose = function () {
        this.quit();
    };
    Undo.prototype.observe = function () {
        var newState = json_1.json.save(this.state);
        if (!this.enabled) {
            this.enabled = true;
        }
        else {
            this.redoStack.length = 0;
            this.undoStack.push(this.currentState);
        }
        var previousState = this.currentState;
        this.currentState = newState;
        if (this.transactionCompleted) {
            this.transactionCompleted(this.currentState, previousState);
        }
    };
    Undo.prototype.swap = function (source, target) {
        var popped = source.pop();
        if (popped) {
            target.push(this.currentState);
            this.enabled = false;
            json_1.json.load(this.state, popped);
        }
    };
    Object.defineProperty(Undo.prototype, "canUndo", {
        get: function () {
            return !!this.undoStack.length;
        },
        enumerable: true,
        configurable: true
    });
    Undo.prototype.undo = function () {
        this.swap(this.undoStack, this.redoStack);
    };
    Object.defineProperty(Undo.prototype, "canRedo", {
        get: function () {
            return !!this.redoStack.length;
        },
        enumerable: true,
        configurable: true
    });
    Undo.prototype.redo = function () {
        this.swap(this.redoStack, this.undoStack);
    };
    return Undo;
}());
__decorate([
    mobx_1.observable.shallow
], Undo.prototype, "undoStack", void 0);
__decorate([
    mobx_1.observable.shallow
], Undo.prototype, "redoStack", void 0);
__decorate([
    mobx_1.action.bound
], Undo.prototype, "undo", null);
__decorate([
    mobx_1.action.bound
], Undo.prototype, "redo", null);
exports.Undo = Undo;
//# sourceMappingURL=Undo.js.map